import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import * as yup from 'yup';


interface IDistributorContext {
    isNew: boolean
    isLoading: boolean
    isSaving: boolean
    distributor: Distributor

    saveDistributor: (distributor: Distributor) => Promise<void>
}


export let distributorSchema = yup.object({
    id: yup.string().default(''),
    firstName: yup.string().default('').required().label("Firstname"),
    lastName: yup.string().default('').required().label("Lastname"),
    email: yup.string().default('').required().label("Email"),
    companyName: yup.string().default(''),
    canAddDealers: yup.boolean().default(true),
    countries: yup.array(yup.string()).default([]).min(1, "At least one country must be specified"),
    brands: yup.array(yup.string()).default([]).min(1, "At least one brand must be specified")
})

export type Distributor = yup.InferType<typeof distributorSchema>;

export let distributorContext = React.createContext({} as IDistributorContext);

let { Provider } = distributorContext;

let DistributorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();
    let { enqueueSnackbar } = useSnackbar();
    let location = useLocation();
    let history = useHistory();

    let isNew = location.pathname.includes('/addnew');

    let [isLoading, setLoading] = useState(isNew === false);
    let [distributor, setDistributor] = useState<Distributor>(distributorSchema.getDefault());
    let [isSaving, setSaving] = useState(false);


    useEffect(() => {
        if (id)
            getDistributor(id);
    }, [id])


    let getDistributor = async (id: string) => {
        try {
            let res = await axios.get('/api/User/GetDistributor', { params: { id } });
            setDistributor(res.data.item);
        } catch (err) {
            enqueueSnackbar("Unable to get user", { variant: 'error' });
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    let saveDistributor = async (distributor: Distributor) => {
        try {
            setSaving(true);
            await axios.post('/api/User/SaveDistributor', distributor);
            history.push('/admin/distributors');
        } catch (err) {
            setSaving(false);
        }
    }

    return (
        <Provider
            value={{
                isNew,
                isLoading,
                isSaving,
                distributor,

                saveDistributor
            }}
        >
            {children}
        </Provider>
    )
}

export default DistributorProvider;